enum Currency {
  USD = 'USD',
  CAD = 'CAD',
  MXN = 'MXN',
  EUR = 'EUR',
}

export { Currency };
